import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'


@Component({
  selector: 'app-food',
  templateUrl: './food.component.html',
  styleUrls: ['./food.component.css']
})
export class FoodComponent implements OnInit {

  public allFoodResp;
  public foodServiceResp;
  public isFoodResp = false
  public currentUser;
  public pincode;
  public serviceType;

  serviceForm = this
    .formBuilder
    .group({
      search_term: [
        '', Validators.required
      ],
      pincode: [
        '', [Validators.required,Validators.pattern(/^[0-9]+([,.][0-9]+)?$/),Validators.minLength(5),Validators.maxLength(5)]
      ]
    });

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {

    let emergencyService = localStorage.getItem("emergencyservice");
    console.log(emergencyService);
    if(emergencyService == "food"){
      this.serviceType = "Food"
    } 
    else if(emergencyService == "goods"){
      this.serviceType = "Material Goods"
    }
    else if(emergencyService == "utilities"){
      this.serviceType = "Utilities"
    }
    else if(emergencyService == "housing"){
      this.serviceType = "Housing/Shelter"
    }
    else if(emergencyService == "transport"){
      this.serviceType = "Transportation"
    }
    else{
      console.log("no service selected")
    }
    this.getService();
  }

  getService() {
    let input : {}
    input = {
      "service_type": this.serviceType
    }
    this.commonService.getAllServices(input).subscribe(res => {
      this.allFoodResp = res.body.data;
    })
  }

  
  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }
 

  getFoodServiceEmail(email){
    console.log('email of food service provider', email);
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }
 

  redirectTologin(){

    if(this.serviceForm.value.search_term != undefined && this.serviceForm.value.search_term != ""  && this.serviceForm.value.pincode != ""){
      console.log('save submit',this.serviceForm.value);
      localStorage.setItem('Eservice', this.serviceForm.value.search_term);
      localStorage.setItem('EservicePincode', this.serviceForm.value.pincode);

      let isAdditionalHelp = localStorage.getItem('isAdditionalHelp');

      if(isAdditionalHelp == "true"){
        this.router.navigate(['/food-service'])
      } else {
        this.router.navigate(['/login']);

      }
    }
    else{
      alert("Please fill all the details");
    }
    
    // this.currentUser =  JSON.parse(localStorage.getItem('currentUser'));
    // // this.pincode = this.currentUser.zip_code;

    // this.commonService.searchFoodService(this.foodForm.value).subscribe(res => {
    //   this.isFoodResp = true;
    //   this.foodServiceResp = res.body.data;
    //   console.log(this.foodServiceResp,'foodresp')
    // })

  }

}
